<template>
    <a href="javascript:void(0)" class="tabs__trigger" @click="handleClick(name), scrollTo()" v-bind:class="{active: active == name}">
        <slot />
    </a>
</template>

<script>
export default {
    name: 'TabsTriggerComponent',
    props: {
        handleClick: Function,
        name: String,
        active: String
    },

    methods: {
        scrollTo() {
            if ($(window).width() < 800) {
                window.location.href = "#virtualtour";
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// TabsTrigger.vue?b2b5d750